const PageNotFound = () => {
    return(
        <section
        className="my-20 px-32 flex justify-center items-center h-screen max-sm:px-8 max-sm:h-auto max-sm:my-32"
      >
       Page Not Found
      </section>
    )
}

export default PageNotFound